export function templateFieldPhase(config) {
    return config?.phase ?? 'creation';
}
//# sourceMappingURL=template-field-phase.js.map